import {
  type DirectionFacing,
  type FrameMaterial,
  type Operability,
} from '#packages/data-collection/models/audit-windows-form';

export const DirectionFacingLabel: Record<DirectionFacing, string> = {
  N: 'North',
  E: 'East',
  W: 'West',
  S: 'South',
  NE: 'Northeast',
  NW: 'Northwest',
  SE: 'Southeast',
  SW: 'Southwest',
};

export const OperabilityLabel: Record<Operability, string> = {
  operable: 'Operable',
  fixed: 'Fixed',
};

export const FrameMaterialLabel: Record<FrameMaterial, string> = {
  aluminum: 'Aluminum',
  wood: 'Wood',
  vinyl: 'Vinyl',
};

export const GlazingPanesOptions = [1, 2, 3] as const;
export const GlazingPanesLabel: Record<number, string> = {
  1: 'Single',
  2: 'Double',
  3: 'Triple',
};
